var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 15,
    width: 30,
    height: 26,
    rx: 4,
    stroke: "#699D8C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12C18.5 9.23858 20.7386 7 23.5 7H25.5C28.2614 7 30.5 9.23858 30.5 12V15H18.5V12Z",
    stroke: "#699D8C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6098 30C24.5457 29.9908 24.4634 29.9908 24.3902 30C22.7805 29.945 21.5 28.626 21.5 27.0046C21.5 25.3466 22.8354 24 24.5 24C26.1555 24 27.5 25.3466 27.5 27.0046C27.4909 28.626 26.2195 29.945 24.6098 30Z",
    stroke: "#699D8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 29,
    width: 2,
    height: 7,
    rx: 1,
    fill: "#699D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordServices);
export default __webpack_public_path__ + "static/media/password-services.b6d8df29.svg";
export { ForwardRef as ReactComponent };